/**
 * FCT Account API
 * FCT Account API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: areche@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The SignContractResponse model module.
 * @module model/SignContractResponse
 * @version 1.0.0
 */
class SignContractResponse {
    /**
     * Constructs a new <code>SignContractResponse</code>.
     * @alias module:model/SignContractResponse
     */
    constructor() { 
        
        SignContractResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SignContractResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SignContractResponse} obj Optional instance to populate.
     * @return {module:model/SignContractResponse} The populated <code>SignContractResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SignContractResponse();

            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'String');
            }
            if (data.hasOwnProperty('msg')) {
                obj['msg'] = ApiClient.convertToType(data['msg'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {String} status
 */
SignContractResponse.prototype['status'] = undefined;

/**
 * @member {String} msg
 */
SignContractResponse.prototype['msg'] = undefined;






export default SignContractResponse;

